module.exports = __webpack_public_path__ + "img/skattedag_5.52ec9522.png";